import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class APIHeaderService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }

    // public getAllNewRootHeaders(): Observable<any> {
        // const url = this.getUrl();
        // return this.http.get(APIConstants.GETALLROOTHEADERSFORTSP+"TATA");
          
    // } 
    
    // private getUrl(): any {
        // const role = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);
        // const Entity_Ref_No = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
        // if(role === 'PE'){
            // APIConstants.ROLE.GETALLROOTHEADERSFORTSP + "TATA" ;
        // } 
        // else
            // APIConstants.ROLE.GETALLROOTHEADERFORAPPROVAL + Entity_Ref_No;

    // }

    // public getAllRootHeaderForApproval(): Observable<any> {
        // return this.http.get(APIConstants.GETALLROOTHEADERFORAPPROVAL+"TATA");
    // }

    public approveHeader(data): Observable<any> {
        let a= this.http.post(APIConstants.UPDATESTATUSHEADERSMS, data);

        return a;
    }
	
	    public approveHeaderNew(data): Observable<any> {
        let a= this.http.post(APIConstants.UPDATESTATUSHEADERSMSNEW, data);

        return a;
    }
	

    // public approveRootHeader(data): Observable<any> {
        // let a= this.http.post(APIConstants.UPDATESTATUSROOTHEADER, data);

        // return a;
    // }
    

    // public getAllRootHeaderForTSP(): Observable<any> {
        // return this.http.get(APIConstants.GETALLROOTHEADERSFORTSP+"TA");
    // }
  
    public getAllApprovedRootHeaders(data):Observable<any> {
        return this.http.get(APIConstants.GETALLAPPROVEDROOTHEADERS+data);
    }
  
  
    public getNewHeaderSummary(tsp): Observable<any> {
        return this.http.get(APIConstants.GET_HEADERS_FOR_APPROVAL+tsp);
          
    }
    
    // public ListRootHeaderSMSPending(): Observable<any>{
        // return this.http.get(APIConstants.LISTROOTHEADERSMS+'/'+"P");
    // }
	 // public ListRootHeaderSMS(): Observable<any>{
        // return this.http.get(APIConstants.LISTROOTHEADERSMS+'/'+"P");
    // }
	// public ListAllRootHeaderSMS(): Observable<any>{
        // return this.http.get(APIConstants.LISTROOTHEADERSMS+ '/' + "A");
    // }
    public ListRootHeaderSMSActive(role): Observable<any>{
        return this.http.post(APIConstants.LISTENTITYROOTHEADERSMS, role);
    }
	
	 public listHeaderVoiceDLT(data): Observable<any>{
        return this.http.get(APIConstants.LISTHEADERVOICEDLT);
    }
	
	public getAllPrincipalEntity(): Observable<any>{
        return this.http.get(APIConstants.GETALLPRINCIPALENTITY);
     }
	
	 public listPrincipalEntityHeaderSMS(data): Observable<any>{
        return this.http.post(APIConstants.LISTPRINCIPALENTITYSMS, data);
    }
    public listPrincipalEntityHeaderSMSDLT(data): Observable<any>{
        return this.http.get(APIConstants.LISTPRINCIPLEENTITYHEADERSMSDLT + '/' +data);
    } 
    public ListHeaderSMS(): Observable<any>{
        const role = this.db.get(Constants.SESSSION_STORAGE, Constants.USER_ROLE);

            return this.http.get(APIConstants.LISTHEADERSMS+'/'+"P");

		
    } 
	 public ListHeaderSMSDLT(): Observable<any>{
        return this.http.get(APIConstants.LISTHEADERSMSDLT );
    } 
 
    
    public getAllHeaderSummary(role,param): Observable<any> {
         return this.http.get(APIConstants.GETALLHEADERS+param);  
 
    }

    public getAllApprovedHeaders(pid): Observable<any> {
        return this.http.get(APIConstants.GETALLAPPROVEDHEADERS+pid);
          
    }

     public headerRegistration(data: any): Observable<any>{
         return this.http.post(APIConstants.REGISTERHEADER,data);

      }
    //filters
    public getAllUnApprovedHeadersFilter(param,fdate,ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLHEADERSFORAPPROVALFILTER+param+'/'+fdate+'/'+ldate);
          
    }
    
    public getAllHeadersFilter(param,fdate,ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLHEADERSFORAPPROVALFILTER+param+'/'+fdate+'/'+ldate);
          
    }
  
   
    public getAllUnApprovedRootHeadersFilter(param,fdate,ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLROOTHEADERFORAPPROVALFILTER+param+'/'+fdate+'/'+ldate);
          
    }
    
    public getAllRootHeadersFilter(param,fdate,ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLROOTHEADERFILTER+param+'/'+fdate+'/'+ldate);
          
    }

	public ListHeaderVoice(data): Observable<any> {
        return this.http.get(APIConstants.LISTHEADERVOICE+'/'+data);
    }
    
	public ListPricipleEntityHeaderVoiceDLT(data): Observable<any> {
        return this.http.get(APIConstants.LISTPRICIPLEENTITYHEADERVOICEDLT+'/'+data);
    }
	public listTeleEntityHeaderSMSDLT(data): Observable<any> {
        return this.http.get(APIConstants.LISTTELEENTITYHEADERSMSDLT+'/'+data);
    }
	
	public listTelemarketerEntityHeaderSMS(data): Observable<any> {
        return this.http.post(APIConstants.LISTTELEMARKETERHEADERSMS,data);
    }
	public ListTelemarketerEntityHeaderVoice(data): Observable<any> {
        return this.http.post(APIConstants.LISTTELEMARKETERENTITYHEADERVOICE,data);
    }
	public ListTeleEntityHeaderVoiceDLT(data): Observable<any> {
        return this.http.get(APIConstants.LISTTELEMARKETERENTITYHEADERVOICEDLT+ '/'+data);
    }
	
    public RegisterHeaderVoice(data): Observable<any> {
	
        return this.http.post(APIConstants.REGISTERHEADERVOICE,data);
    }
	
	 public ListPrincipalEntityHeaderVoice(data): Observable<any> {
        return this.http.post(APIConstants.LISTPRICIPLEENTITYHEADERVOICE,data);
    }

	 public UpdateStatusHeaderVoice(data): Observable<any> {
        let a= this.http.post(APIConstants.UPDATESTATUSHEADERVOICE, data);
		return a;
    }


    //deactivate the header 
public deactivateHeaderService(data): Observable<any>{
    return this.http.post(APIConstants.DEACTIVATEHEADERSMS,data)
    }
    public getEntityDetails(data): Observable<any>{
        return this.http.get(APIConstants.GETENTITYDETAILS + '/' +data);
    } 
    public downloadcsv(): Observable<any>{
        return this.http.get(APIConstants.DOWNLOADHEADERDETAILS ,{responseType: "blob"});
    }
    public downloadcsvDLT(): Observable<any>{
        return this.http.get(APIConstants.DOWNLOADHEADERDETAILSDLT ,{responseType: "blob"});
    }
    public downloadrootcsv(data): Observable<any>{
        return this.http.get(APIConstants.DOWNLOADROOTHEADERDETAILS+ '/'+data,{responseType: "blob"});
    }
    
    public getOneHeaderFromMongo(data): Observable<any> {     
      	   
        return this.http.post(APIConstants.GETONEHEADERFOMMONGO,data);        

    }
    public headerFileDownload(file1): Observable<any> {  

        return this.http.post(APIConstants.HEADERFILEDOWNLOAD, file1, { responseType: "blob" });
    }
    public headersbype(data): Observable<any> {     
      	   
        return this.http.post(APIConstants.GETHEADERSBYPE,data);        

    } 
    public modifyHeader(data): Observable<any> {
        let a= this.http.post(APIConstants.MODIFYHEADER, data);
		return a;
    }
    public resendOTPForHeader(data): Observable<any> {
        return this.http.post(APIConstants.RESENDOTPHEADER, data);
    }
    public sendEMOtpForHeader(data): Observable<any> {
        return this.http.post(APIConstants.SENDEMOTPFORHEADER, data);
    }
    public updateMobileEmailInMongo(data): Observable<any> {
        let a= this.http.post(APIConstants.UPDATEMOBILEEMAILINMONGO, data);
		return a;
    }
    public updateMobileEmailInMongoModify(data): Observable<any> {
        let a= this.http.post(APIConstants.UPDATEMOBILEEMAILINMONGOMODIFY, data);
		return a;
    }
    public fetchEntityinHeadTempTable(entityId): Observable<any>{
         return this.http.get(APIConstants.FETCHENTITYINHEADTEMPTALE+ '/'+entityId); 
     }
     public fetchDLTEntityDetails(data): Observable<any>{
        return this.http.get(APIConstants.FETCHDLTENTITYDETAILS+ '/'+data);
    }
    public checkAvailabilityOfHeader(data): Observable<any>{
	   return this.http.post(APIConstants.CHECKAVAILABILTYHEADER,data);
    } 
    public headerRegistrationnew(data): Observable<any>{
         const headers = new HttpHeaders(); 
         headers.set('content-type', 'application/json');  
         headers.set('Accept', 'multipart/form-data');
         headers.set('Access-Control-Allow-Origin',"*");
         return this.http.post(APIConstants.REGISTERHEADERNEW,data,{ headers });
 
      }
      public getHeaderByFilterWorklist(data): Observable<any> {     
        //let status = "P";		   
        return this.http.post(APIConstants.GETHEADERBYFILTERWORKLIST,data);        

    } 
    public exportExcelWL(data): Observable<any> {  
        return this.http.post(APIConstants.EXPORTCSVHEADERWL,data,{ responseType:"blob" });
   }
   public getPendingheaderregworklist(): Observable<any> {     
    let status = "P";		   
    return this.http.get(APIConstants.GETPENDINGHEADERFORWORKLIST+ '/'+status);        

} 

	  //HEader Import
   public importHeader(data): Observable<any> {  


    const headers = new HttpHeaders();
    headers.set('content-type', null);
    headers.set('Accept', 'multipart/form-data');
    headers.set('Access-Control-Allow-Origin',"*");

    let b = this.http.post(APIConstants.IMPORTHEADER, data, { headers });
    return b;

   }
   
    public getHeaderSummaryMongo(status): Observable<any> {    
        return this.http.post(APIConstants.GETHEADERSUMMARYMONGO, status); 
    } 
	
	public getHeaderWorkListFilter(data: any): Observable<any> {
        return this.http.post(APIConstants.GETHEADERWORKLISTFILTER, data);        
    }
    public searchPEHeaderReports(status): Observable<any> {    
        return this.http.post(APIConstants.SEARCHPEHEADERREPORTS, status); 
    }
    public downloadPEHeaderReports(file1): Observable<any> {  

        return this.http.post(APIConstants.DOWNLOADPEHEADERREPORTS, file1, { responseType: "blob" });
    }
    public fetchTMName(tmid): Observable<any>{
	    return this.http.get(APIConstants.FETCHTMNAME+ '/'+tmid); 
    }
	public getbulkHeaderSummary(data): Observable<any> { 
        return this.http.post(APIConstants.GETBULKHEADERSUMMARY,data);

    }
    public downloadHeaderFile(BatchId): Observable<any>{
        return this.http.get(APIConstants.DOWNLOADHEADERFILE+ '/' + BatchId,{responseType: "blob"});
    }
	public getHeaderSummaryFilter(data): Observable<any> {
        return this.http.post(APIConstants.GETBULKHEADERSUMMARYFILTER,data);

    }
	public fetchIndDetailsfrmDB(data): Observable<any> {
        return this.http.get(APIConstants.FETCHINDUSTRYDETAILSFROMDB+ '/'+data);

    }
	public getHeaderBulkDetails(BatchId): Observable<any> {
        return this.http.get(APIConstants.HEADERBULKDETAILS + '/' + BatchId);

    }
	public bulkUploadSchema(schema): Observable<any> {
        return this.http.get(APIConstants.BULKUPLOADSCHEMA + '/' + schema,{responseType: "blob"});

    }
	/// Blacklist in new header registration //dev
    public getblackListingHeader(data): Observable<any> {
        return this.http.post(APIConstants.BLACKLISTINGHEADER,data);

    }
	
	 public getEntityNameDetails(data): Observable<any>{
        return this.http.get(APIConstants.GETENTITYNAMEDETAILS + '/' +data);
    }
    public getHeaderDetails(data): Observable<any>{
        return this.http.get(APIConstants.GETHEADERDETAILS + '/' +data);
    }	
    //Added for VerifyHeader
      public verifyHeader(data): Observable<any> {
        return this.http.post(APIConstants.VERIFYHEADER,data);
    }
    public temporaryHeaderExtension(data): Observable<any> {
        return this.http.post(APIConstants.TEMPORARYHEADEREXTENSION, data);		
    }

    public temporaryHeaderConversion(data): Observable<any> {          	   
        return this.http.post(APIConstants.TEMPORARYHEADERCONVERSION,data);        
    }

    public suspendHeaderByPE(data): Observable<any> {
        return this.http.post(APIConstants.SUSPENDHEADERBYPE,data);   
    }

    public revokeHeaderByPE(data): Observable<any> {
        return this.http.post(APIConstants.REVOKEHEADERBYPE,data);   
    }
}